import React, { useState } from 'react'
import { useEffect } from 'react';
import { getDefaultName } from '../utils';
import { loadLanguage, loadTalent, loadUserTalent } from '../utils/Network';

export default function LanguageName({ id}) {

    const [language, setLanguage] = useState(null);

    
    useEffect(() => {
        if (id)
            loadLanguage(id).then(language=>{
                setLanguage(language)
            })
        
    }, [])

    
    
    return (
        <>
            {language && language.name}
        </>
    )
}
